import FormModelFactory from './factories/FormModelFactory';
import { isUrl } from './validators/validators';

export default FormModelFactory({
    fields: {
        url: { validators: [isUrl()] },
    },
    options: { onlyDiff: false },
});
